module.exports = __webpack_public_path__ + "img/RedMilestone.754e6368.svg";